import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CalendarIcon, UserIcon } from 'lucide-react';
import { SEOHead } from '../components/SEOHead';
import { ScrollReveal } from '../components/ScrollReveal';
export function BlogPage() {
  const posts = [{
    title: 'Missed Call Text-Back: What It Is and Why It Matters',
    excerpt: "A missed call doesn't have to be a lost job. Here's what missed call text-back actually is and why it matters for home service businesses.",
    date: 'Speed to Lead',
    author: 'Kevin Rogers',
    image: 'https://cdn.magicpatterns.com/previews/artifact/8ef41a74-f750-41df-9bed-d463f28483ef.png',
    slug: '/blog/missed-call-text-back-phoenix-home-services',
    category: 'Speed to Lead'
  }, {
    title: 'How to Choose a Marketing Agency: Expert Guide',
    excerpt: "Choosing a marketing agency shouldn't feel like a shot in the dark. Learn how to evaluate agencies based on real capabilities, not just promises.",
    date: 'October 24, 2023',
    author: 'Kevin Rogers',
    image: 'https://cdn.magicpatterns.com/uploads/1ZRagfTNeZ9TVoJaQJEfup/rsw_1280.webp',
    slug: '/blog/how-to-choose-marketing-agency',
    category: 'Expert Guide'
  }, {
    title: 'Why Response Time Makes or Breaks Your Yelp Ads',
    excerpt: "Slow replies are the most common reason Yelp ad spend underperforms. Here's why response time decides who wins the job, and how to fix it.",
    date: 'Online Advertising',
    author: 'Kevin Rogers',
    image: 'https://cdn.magicpatterns.com/previews/artifact/8ef41a74-f750-41df-9bed-d463f28483ef.png',
    slug: '/blog/why-response-time-makes-or-breaks-your-yelp-ads',
    category: 'Online Advertising'
  }, {
    title: 'Faster Yelp Replies, More Landscaping Estimates',
    excerpt: "For landscaping companies, the estimate goes to whoever replies first. Here's how faster Yelp responses turn into more booked jobs.",
    date: 'Landscaping',
    author: 'Kevin Rogers',
    image: 'https://cdn.magicpatterns.com/previews/artifact/8ef41a74-f750-41df-9bed-d463f28483ef.png',
    slug: '/blog/faster-yelp-replies-more-landscaping-estimates',
    category: 'Landscaping'
  }, {
    title: 'AI Receptionist vs. Human Receptionist: Real Cost Comparison',
    excerpt: 'How much does it actually cost to hire a receptionist versus using an AI receptionist? A real breakdown of costs, pros, and cons.',
    date: 'Cost Comparison',
    author: 'Kevin Rogers',
    image: 'https://cdn.magicpatterns.com/previews/artifact/8ef41a74-f750-41df-9bed-d463f28483ef.png',
    slug: '/blog/ai-receptionist-vs-human-receptionist-cost',
    category: 'Cost Comparison'
  }];
  return <div className="bg-viridia-black min-h-screen pt-24 pb-16" data-id="element-1735" data-mp="1cqtr6y06n0el">
      <SEOHead title="Marketing Insights & Strategies | Viridia Analytics Blog" description="Expert marketing advice, strategies, and insights for local home service businesses, contractors, and operators." canonical="/blog" keywords="marketing blog, local business marketing, home services marketing, contractor marketing tips, AI marketing strategies" data-id="element-1736" data-mp="1hjd19kznvden" />

      {/* HERO SECTION */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center" data-id="element-1737" data-mp="371jo1bpxysvd">
        <ScrollReveal data-id="element-1738" data-mp="2jbpdj0t3hgea">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-viridia/10 text-viridia text-sm font-semibold tracking-wide uppercase mb-6 border border-viridia/20" data-id="element-1739" data-mp="2jb63e69orwat">
            INSIGHTS & STRATEGY
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 tracking-tight" data-id="element-1740" data-mp="2s8zqqrph3flu">
            The Viridia <span className="text-viridia" data-id="element-1741" data-mp="7ktsk6ec86vg">Blog</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-1742" data-mp="7n6hj3iijhi0">
            Actionable marketing advice, industry insights, and proven
            strategies to help local service businesses stop losing leads and
            start booking more jobs.
          </p>
        </ScrollReveal>
      </section>

      {/* BLOG GRID */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-1743" data-mp="17umoalzsrl77">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1744" data-mp="17wfvq3i8i9g9">
          {posts.map((post, i) => <ScrollReveal key={i} delay={i * 0.1} data-id="element-1745" data-mp="1hsj25lk4cu90" data-mpi={i}>
              <Link to={post.slug} className="group block h-full" data-id="element-1746" data-mp="1hs16or5a6k25">
                <div className="bg-viridia-surface border border-gray-800 rounded-2xl overflow-hidden h-full flex flex-col hover:border-viridia/50 transition-colors duration-300" data-id="element-1747" data-mp="1ltcmy629lsxo">
                  <div className="relative h-48 overflow-hidden" data-id="element-1748" data-mp="1vjo44uaylymi">
                    <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-1749" data-mp="1vm1wgve98wqd" />
                    <div className="absolute top-4 left-4 bg-viridia-black/80 backdrop-blur-sm border border-gray-700 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-1750" data-mp="3q0p7dgbqiqk6">
                      {post.category}
                    </div>
                  </div>
                  <div className="p-6 flex flex-col flex-grow" data-id="element-1751" data-mp="3g42nouv5a5jq">
                    <div className="flex items-center gap-4 text-xs text-gray-500 mb-4" data-id="element-1752" data-mp="3b3yelpwkgd3j">
                      <div className="flex items-center gap-1" data-id="element-1753" data-mp="ck810j4wv4ah">
                        <CalendarIcon className="w-3 h-3" data-id="element-1754" data-mp="7m6gdtru6www" />
                        {post.date}
                      </div>
                      <div className="flex items-center gap-1" data-id="element-1755" data-mp="2uohdb9dj6ek">
                        <UserIcon className="w-3 h-3" data-id="element-1756" data-mp="2t3n7mqz1ph8" />
                        {post.author}
                      </div>
                    </div>
                    <h2 className="text-xl font-bold text-white mb-3 group-hover:text-viridia transition-colors" data-id="element-1757" data-mp="vcspzphhop90">
                      {post.title}
                    </h2>
                    <p className="text-gray-400 text-sm leading-relaxed mb-6 flex-grow" data-id="element-1758" data-mp="2kt4opt17bwhf">
                      {post.excerpt}
                    </p>
                    <div className="inline-flex items-center text-viridia font-semibold text-sm mt-auto" data-id="element-1759" data-mp="2prfy62nl44z4">
                      Read Article{' '}
                      <ArrowRightIcon className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-1760" data-mp="2g1wj782zsv9j" />
                    </div>
                  </div>
                </div>
              </Link>
            </ScrollReveal>)}
        </div>
      </section>
    </div>;
}